import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router";
import { $ServiceAddressCreate, ServiceAddressesVService } from '../../services/V2/gozer';
import { ServiceAddressesVService as ServiceAddressesV2Service, $ServiceAddressUpdate } from '../../services/V2/gozer';
import { EditModal } from '../shared/EditModal';
import { AddModal } from '../shared/AddModal';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PublishIcon from '@material-ui/icons/Publish';
import { authProvider } from '../../services/Security';
import { BulkUpload } from './BulkUpload';
import { DistrictsVService } from '../../services/V2/padre';
import { handleError } from '../shared/Functions';
import { CustomTable } from '../shared/CustomTable';

export const ServiceAddresses = () => {
    const history = useHistory();

    const [loading, setLoading] = useState<boolean>(true);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [showUpload, setShowUpload] = useState<boolean>(false);
    const [district, setDistrict] = useState<any>();
    const [districtId, setDistrictId] = useState<any>();
    const [token, setToken] = useState<any>();
    const [rowData, setRowData] = useState<any>();
    const [canUpdateServiceAddress, setCanUpdateServiceAddress] = useState<boolean>(false);
    const [canCreateServiceAddress, setCanCreateServiceAddress] = useState<boolean>(false);
    const [canReadMeters, setCanReadMeters] = useState<boolean>(false);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setDistrictId(data?.districtId)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        if (!token || !districtId) return;
        DistrictsVService.districtsVGetById(districtId ?? "")
            .then(x => setDistrict(x))
            .catch(x => handleError(x))

        let perms = authProvider.getPermissions();
        setCanUpdateServiceAddress(perms.some((perm: string) => perm === "UpdateServiceAddresses"));
        setCanCreateServiceAddress(perms.some((perm: string) => perm === "CreateServiceAddresses"));
        setCanReadMeters(perms.some((perm: string) => perm === "ReadMeters"));
    }, [token, districtId])// eslint-disable-line react-hooks/exhaustive-deps

    const handleShowEdit = (row) => {
        setRowData(row)
        setShowEdit(true);
    }

    return (
        <React.Fragment>
            {showEdit &&
                <EditModal
                    modelId={rowData.id}
                    parentId={null}
                    parentsParentId={null}
                    data={rowData}
                    modelName="Service Address"
                    setShow={setShowEdit}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={ServiceAddressesVService.serviceAddressesVUpdateServiceAddress}
                    extraEndpoint={null}
                    deleteEndpoint={null}
                    viewKeys={null}
                    editKeys={$ServiceAddressUpdate.properties}
                    extraKeys={null}
                    hardDelete={false}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showAdd &&
                <AddModal
                    setShow={setShowAdd}
                    show={showAdd}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={ServiceAddressesVService.serviceAddressesVCreate}
                    keys={$ServiceAddressCreate.properties}
                    modelName="Service Address"
                    parentId={null}
                    parentsParentId={null}
                    parent={district}
                    parentValues={["districtId"]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showUpload &&
                <BulkUpload setShow={setShowUpload} setLoading={setLoading} loading={loading} district={district} />
            }
            <CustomTable
                title="Service Addresses"
                columns={[
                    { title: 'Id', field: 'id', editable: 'never' },
                    { title: 'Type', field: 'type', editable: 'never' },
                    { title: 'Street', field: 'street', editable: 'never' },
                    { title: 'City', field: 'city', editable: 'never' },
                    { title: 'State', field: 'state', editable: 'never' },
                    { title: 'Zip', field: 'zip', editable: 'never' },
                    { title: 'Zip4', field: 'zip4', editable: 'never' },
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!districtId) resolve({
                            data: [],
                            page: query.page,
                            totalCount: 0
                        })
                        else
                            ServiceAddressesV2Service.serviceAddressesVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Id",
                                orderByDesc: query.orderDirection === "desc",
                                filters: [{
                                    property: "DistrictId",
                                    value: districtId
                                }],
                                searchQuery: query.search
                            }).then((x: any) => {
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                })
                            }).catch(x => {
                                reject(x)
                            })
                    })
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => { setLoading(!loading) },
                    },
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add Service Address',
                        isFreeAction: true,
                        onClick: () => setShowAdd(true),
                        disabled: !canCreateServiceAddress
                    },
                    {
                        icon: () => <PublishIcon />,
                        tooltip: 'Upload Service Addresses or Meters',
                        isFreeAction: true,
                        onClick: () => setShowUpload(true),
                        disabled: !canCreateServiceAddress
                    },
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Service Address',
                        onClick: (event, row) => handleShowEdit(row),
                        disabled: !canUpdateServiceAddress
                    },
                    {
                        icon: () => <AccessTimeIcon />,
                        tooltip: 'View Meters',
                        onClick: (e, r: any) => history.replace(`/app/service-addresses/${r.id}/meters`),
                        disabled: !canReadMeters
                    }
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}